import React from 'react'
import { Link } from "react-router-dom";
import ButtonUI from '../../../widgets/action/ButtonUI'
import SwitchUI from '../../../widgets/action/SwitchUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import SPUpdateModalSF from './SPUpdateModalSF'
import './ScoreParameters.css'

const ScoreParamsUI = ({ context, account, params, provisionalYear, onRefreshClick,
  updateMode, updClk, onCancelClick, onUpdate,
  showUnused, onShowUnusedCick, onHideUnusedCick,
  allYrs, onShowAllClick, onShowRecentClick,
  updateProvisionalsMode, onUpdateProvisionals,
  // update form variables
  parameterName, financialYear, parameterValue,
  //
  toggleEditable, edit,
  onToggleMcaItr, itr, onToggleClassicStp, stp
}) =>
  <div className='su_sp'>
    <LRTableActionsUI location='top'
      left={
        <span className='g_flex_left g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          <span className='g_m_left_100 g_large'><b>Score Parameters</b></span>
        </span>
      }
      right={
        <span className='g_flex_right g_flex_h'>
          <UpdateProvisionals updateProvisionalsMode={updateProvisionalsMode} onUpdateProvisionals={onUpdateProvisionals} />
          <Link to='#' onClick={toggleEditable}>Details</Link>
          <SwitchUI label='STP' className='g_m_left_100' checked={stp} onChange={onToggleClassicStp} />
          <SwitchUI label='MCA-ITR' className='g_m_left_100' checked={itr} onChange={onToggleMcaItr} />
        </span>
      }
    />
    {
      !params &&
      <SpinnerComponentUI />
    }
    {
      params &&
      <table><thead className='g_sticky'>
        <tr><td />
          <td>
            {!allYrs && <ButtonUI onClick={onShowAllClick} transparent={true} label='>>>>>>>>' />}
            {allYrs && <ButtonUI onClick={onShowRecentClick} transparent={true} label='<<<<<<<<' />}
          </td>
          {
            params.map((row, i) =>
              <React.Fragment key={i}>
                {
                  (i == params.length - 3 || i == params.length - 2 || i == params.length - 1) &&
                  <td className='right'>
                    <div className='g_m_left_100'><b className='g_no_wrap'>{row.financialYear}</b></div>
                    {
                      i !== params.length - 1 && row.financialYear !== provisionalYear &&
                      <span className='g_small'>Audited</span>
                    }
                    {
                      row.financialYear === provisionalYear &&
                      <span className='g_small'>Provisional</span>
                    }
                    {
                      i === params.length - 1 && row.financialYear !== provisionalYear &&
                      <span className='g_small'>-</span>
                    }
                  </td>
                }
                {
                  (i != params.length - 3 && i != params.length - 2 && i != params.length - 1) && allYrs &&
                  <td className='right g_ultra_muted'>
                    <div className='g_m_left_100'><b className='g_no_wrap'>{row.financialYear}</b></div>
                    {
                      (i !== params.length - 2 && i !== params.length - 1) &&
                      <span className='g_small'>Audited</span>
                    }
                  </td>
                }
              </React.Fragment>
            )
          }
          <td className='spacer-right'></td>
        </tr>
      </thead>
        <tbody style={{ maxHeight: '400px', overflowY: 'auto' }}>
          <RowM params={params} allYrs={allYrs} id='1' updClk={updClk} edit={edit} stp={stp} itr={itr} name='totalRevenue' />
          <RowM params={params} allYrs={allYrs} id='2' updClk={updClk} edit={edit} stp={stp} itr={itr} name='totalExpenses' />
          <RowM params={params} allYrs={allYrs} id='3' updClk={updClk} edit={edit} stp={stp} itr={itr} name='interestPaid' />
          <RowM params={params} allYrs={allYrs} id='4' updClk={updClk} edit={edit} stp={stp} itr={itr} name='netProfit' />
          <RowM params={params} allYrs={allYrs} id='5' updClk={updClk} edit={edit} stp={stp} itr={itr} name='cashProfit' />
          <RowM params={params} allYrs={allYrs} id='6 *' updClk={updClk} edit={edit} stp={stp} itr={itr} name='cashProfitPercent' />
          <RowM params={params} allYrs={allYrs} id='7' updClk={updClk} edit={edit} stp={stp} itr={itr} name='ebitda' />
          <RowM params={params} allYrs={allYrs} id='8' updClk={updClk} edit={edit} stp={stp} itr={itr} name='totalReceivables' />
          <RowM params={params} allYrs={allYrs} id='9' updClk={updClk} edit={edit} stp={stp} itr={itr} name='fixedAssets' />
          <RowM params={params} allYrs={allYrs} id='10' updClk={updClk} edit={edit} stp={stp} itr={itr} name='currentAssets' />
          <RowM params={params} allYrs={allYrs} id='11' updClk={updClk} edit={edit} stp={stp} itr={itr} name='cash' />
          <RowM params={params} allYrs={allYrs} id='12' updClk={updClk} edit={edit} stp={stp} itr={itr} name='totalLiability' />
          <RowM params={params} allYrs={allYrs} id='13' updClk={updClk} edit={edit} stp={stp} itr={itr} name='proprietorCapital' />
          <RowM params={params} allYrs={allYrs} id='14' updClk={updClk} edit={edit} stp={stp} itr={itr} name='chargeValue' />
          <RowM params={params} allYrs={allYrs} id='15' updClk={updClk} edit={edit} stp={stp} itr={itr} name='totalLoansClosing' />
          <RowM params={params} allYrs={allYrs} id='16' updClk={updClk} edit={edit} stp={stp} itr={itr} name='totalLoansOpening' />
          <RowM params={params} allYrs={allYrs} id='17' updClk={updClk} edit={edit} stp={stp} itr={itr} name='newLoans' />
          <RowM params={params} allYrs={allYrs} id='18' updClk={updClk} edit={edit} stp={stp} itr={itr} name='totalCurrentLiability' />
          <RowM params={params} allYrs={allYrs} id='19' updClk={updClk} edit={edit} stp={stp} itr={itr} name='totalDepreciation' />
          <RowM params={params} allYrs={allYrs} id='20 -' updClk={updClk} edit={edit} stp={stp} itr={itr} name='dscr' />
          <RowM params={params} allYrs={allYrs} id='21 *' updClk={updClk} edit={edit} stp={stp} itr={itr} name='loanToValue' />
          <RowM params={params} allYrs={allYrs} id='21.1 *' updClk={updClk} edit={edit} stp={stp} itr={itr} name='loanToValueWithoutCFLoan' />
          <RowM params={params} allYrs={allYrs} id='22 *' updClk={updClk} edit={edit} stp={stp} itr={itr} name='revenueToLoanRatio' />
          <RowM params={params} allYrs={allYrs} id='23 *' updClk={updClk} edit={edit} stp={stp} itr={itr} name='liabilityToRevenueRatio' />
          <RowM params={params} allYrs={allYrs} id='24 *' updClk={updClk} edit={edit} stp={stp} itr={itr} name='netDebtToEbitdaRatio' />
          <RowM params={params} allYrs={allYrs} id='25 *' updClk={updClk} edit={edit} stp={stp} itr={itr} name='receivablesToIncomeRatio' />
          <RowM params={params} allYrs={allYrs} id='26 *' updClk={updClk} edit={edit} stp={stp} itr={itr} name='dso' />

          <Row params={params} allYrs={allYrs} id='27' updClk={updClk} edit={edit} name='itrGrossIncomeSM' />
          <Row params={params} allYrs={allYrs} id='28' updClk={updClk} edit={edit} name='itrTotalExpenseSM' />
          <Row params={params} allYrs={allYrs} id='29' updClk={updClk} edit={edit} name='itrTotalCashProfitSM' />
          <Row params={params} allYrs={allYrs} id='30 *' updClk={updClk} edit={edit} name='totalNumberOfChequeBounce' />
          <Row params={params} allYrs={allYrs} id='30.1' updClk={updClk} edit={edit} name='totalChequeBounceAmount' />
          <Row params={params} allYrs={allYrs} id='31' updClk={updClk} edit={edit} name='totalEmiPaidBA' />
          <Row params={params} allYrs={allYrs} id='31.1' updClk={updClk} edit={edit} name='totalEmiPaid' />
          <Row params={params} allYrs={allYrs} id='32' updClk={updClk} edit={edit} name='debitsBankAccountsBA' />
          <Row params={params} allYrs={allYrs} id='33' updClk={updClk} edit={edit} name='creditsBankAccountsBA' />
          <Row params={params} allYrs={allYrs} id='34' updClk={updClk} edit={edit} name='creditExclusionsBA' />
          <Row params={params} allYrs={allYrs} id='35' updClk={updClk} edit={edit} name='debitExclusionsBA' />
          <Row params={params} allYrs={allYrs} id='36' updClk={updClk} edit={edit} name='profitBankAccountsBA' />
          <Row params={params} allYrs={allYrs} id='37' updClk={updClk} edit={edit} name='financeCostBA' />
          <Row params={params} allYrs={allYrs} id='38' updClk={updClk} edit={edit} name='totalLoansBA' />
          <Row params={params} allYrs={allYrs} id='39' updClk={updClk} edit={edit} name='minAccountBalanceBA' />
          <Row params={params} allYrs={allYrs} id='40' updClk={updClk} edit={edit} name='avgAccountBalanceBA' />
          <Row params={params} allYrs={allYrs} id='40.1' updClk={updClk} edit={edit} name='avgAccountBalance' />
          <Row params={params} allYrs={allYrs} id='42' updClk={updClk} edit={edit} name='gstr1TotalRevenue' />
          <Row params={params} allYrs={allYrs} id='43' updClk={updClk} edit={edit} name='gstr2TotalExpense' />
          <Row params={params} allYrs={allYrs} id='44 *' updClk={updClk} edit={edit} name='poCounterParty' />
          <Row params={params} allYrs={allYrs} id='45 *' updClk={updClk} edit={edit} name='companyCreditRating' />
          <Row params={params} allYrs={allYrs} id='46 *' updClk={updClk} edit={edit} name='leadDirectorCreditRating' />
          <Row params={params} allYrs={allYrs} id='47 *' updClk={updClk} edit={edit} name='ldPaid' />
          <Row params={params} allYrs={allYrs} id='48 *' updClk={updClk} edit={edit} name='references' />
          <Row params={params} allYrs={allYrs} id='49 *' updClk={updClk} edit={edit} name='stateCount' />
          <Row params={params} allYrs={allYrs} id='50 *' updClk={updClk} edit={edit} name='litigationCount' />
          <Row params={params} allYrs={allYrs} id='51 *' updClk={updClk} edit={edit} name='trackRecordCompany' />
          <Row params={params} allYrs={allYrs} id='51.1 *' updClk={updClk} edit={edit} name='trackRecordPromoter' />
          <Row params={params} allYrs={allYrs} id='52 *' updClk={updClk} edit={edit} name='delinquencies' />

          <Head label='Triangulation' />
          <Row params={params} allYrs={allYrs} id='53' updClk={updClk} edit={edit} name='revenueTriangulationGST' />
          <Row params={params} allYrs={allYrs} id='54' updClk={updClk} edit={edit} name='revenueTriangulationITR' />
          <Row params={params} allYrs={allYrs} id='55' updClk={updClk} edit={edit} name='revenueTriangulationBank' />
          <Row params={params} allYrs={allYrs} id='56' updClk={updClk} edit={edit} name='expenseTriangulationGST' />
          <Row params={params} allYrs={allYrs} id='57' updClk={updClk} edit={edit} name='expenseTriangulationITR' />
          <Row params={params} allYrs={allYrs} id='58' updClk={updClk} edit={edit} name='expenseTriangulationBank' />
          <Row params={params} allYrs={allYrs} id='59' updClk={updClk} edit={edit} name='cashProfitTriangulationGST' />
          <Row params={params} allYrs={allYrs} id='60' updClk={updClk} edit={edit} name='cashProfitTriangulationITR' />
          <Row params={params} allYrs={allYrs} id='61' updClk={updClk} edit={edit} name='cashProfitTriangulationBank' />
          <Row params={params} allYrs={allYrs} id='64' updClk={updClk} edit={edit} name='debtTriangulationBank' />
          <Row params={params} allYrs={allYrs} id='65' updClk={updClk} edit={edit} name='debtTriangulationITR' />

          <Head label='Other' />
          <Row params={params} allYrs={allYrs} id='1.1' updClk={updClk} edit={edit} name='totalRevenueFromOperations' />
          <Row params={params} allYrs={allYrs} id='21.1' updClk={updClk} edit={edit} name='loanToValueWithoutCFLoan' />
          <Row params={params} allYrs={allYrs} id='21.2' updClk={updClk} edit={edit} name='loanToValueMCA' />
          <Row params={params} allYrs={allYrs} id='22.1' updClk={updClk} edit={edit} name='revenueToNetDebtWithCFLoan' />
          <Row params={params} allYrs={allYrs} id='22.2' updClk={updClk} edit={edit} name='revenueToNetDebtMCA' />
          <Row params={params} allYrs={allYrs} id='23.1' updClk={updClk} edit={edit} name='liabilityToRevenueRatioWithCFLoan' />
          <Row params={params} allYrs={allYrs} id='23.2' updClk={updClk} edit={edit} name='liabilityToRevenueRatioMCA' />
          <Row params={params} allYrs={allYrs} id='24.1' updClk={updClk} edit={edit} name='netDebtToEbitdaWithCFLoan' />
          <Row params={params} allYrs={allYrs} id='24.2' updClk={updClk} edit={edit} name='netDebtToEbitdaRatioMCA' />
          <Row params={params} allYrs={allYrs} id='101' updClk={updClk} edit={edit} name='netDebt' />
          <Row params={params} allYrs={allYrs} id='102' updClk={updClk} edit={edit} name='totalAssets' />
          <Row params={params} allYrs={allYrs} id='103' updClk={updClk} edit={edit} name='investments' />
          <Row params={params} allYrs={allYrs} id='104' updClk={updClk} edit={edit} name='taxPaid' />
          <Row params={params} allYrs={allYrs} id='105' updClk={updClk} edit={edit} name='itrTotalTaxPaid' />
          <Row params={params} allYrs={allYrs} id='106' updClk={updClk} edit={edit} name='changeInDebitAfterAudit' />
          <Row params={params} allYrs={allYrs} id='107' updClk={updClk} edit={edit} name='changeInCreditAfterAudit' />
          <Row params={params} allYrs={allYrs} id='108' updClk={updClk} edit={edit} name='tradeCredits' />
          <Row params={params} allYrs={allYrs} id='109' updClk={updClk} edit={edit} name='tradeDebits' />
          <Row params={params} allYrs={allYrs} id='110' updClk={updClk} edit={edit} name='salaries' />
          <Row params={params} allYrs={allYrs} id='111' updClk={updClk} edit={edit} name='promoterSalaries' />
          <Row params={params} allYrs={allYrs} id='112' updClk={updClk} edit={edit} name='endingCash' />
          <Row params={params} allYrs={allYrs} id='113' updClk={updClk} edit={edit} name='closingCash' />
          <Row params={params} allYrs={allYrs} id='114' updClk={updClk} edit={edit} name='noOfLitigations' />
          <Row params={params} allYrs={allYrs} id='115' updClk={updClk} edit={edit} name='climeLoan' />
          <Row params={params} allYrs={allYrs} id='116' updClk={updClk} edit={edit} name='climeLoanTenureMonths' />
          <Row params={params} allYrs={allYrs} id='117' updClk={updClk} edit={edit} name='climeLoanType' />
          <Row params={params} allYrs={allYrs} id='118' updClk={updClk} edit={edit} name='totalNumberOfLoanDisbursalBA' />
          <Row params={params} allYrs={allYrs} id='119' updClk={updClk} edit={edit} name='totalLoanDisbursalAmountBA' />
          <Row params={params} allYrs={allYrs} id='120' updClk={updClk} edit={edit} name='interestPaidBankAccounts' />
          <Row params={params} allYrs={allYrs} id='121' updClk={updClk} edit={edit} name='totalGrossBlock' />
          <Row params={params} allYrs={allYrs} id='122' updClk={updClk} edit={edit} name='totalNonCurrentAssets' />
          <Row params={params} allYrs={allYrs} id='123' updClk={updClk} edit={edit} name='netWorth' />
          <Row params={params} allYrs={allYrs} id='124' updClk={updClk} edit={edit} name='totalSales' />
          <Row params={params} allYrs={allYrs} id='125' updClk={updClk} edit={edit} name='salesDebitNotes' />
          <Row params={params} allYrs={allYrs} id='126' updClk={updClk} edit={edit} name='salesCreditNotes' />
          <Row params={params} allYrs={allYrs} id='127' updClk={updClk} edit={edit} name='salesAdjustments' />
          <Row params={params} allYrs={allYrs} id='128' updClk={updClk} edit={edit} name='totalPurchases' />
          <Row params={params} allYrs={allYrs} id='129' updClk={updClk} edit={edit} name='purchasesDebitNotes' />
          <Row params={params} allYrs={allYrs} id='130' updClk={updClk} edit={edit} name='purchasesCreditNotes' />
          <Row params={params} allYrs={allYrs} id='131' updClk={updClk} edit={edit} name='purchasesAdjustments' />
          <Row params={params} allYrs={allYrs} id='132' updClk={updClk} edit={edit} name='gstLiability' />
          <Row params={params} allYrs={allYrs} id='133' updClk={updClk} edit={edit} name='inputTaxCreditAvailable' />
          <Row params={params} allYrs={allYrs} id='134' updClk={updClk} edit={edit} name='itrTotalDebt' />
          <Row params={params} allYrs={allYrs} id='135' updClk={updClk} edit={edit} name='debitExclusionsM' />
          <Row params={params} allYrs={allYrs} id='136' updClk={updClk} edit={edit} name='cibilLoans' />
          <Row params={params} allYrs={allYrs} id='137' updClk={updClk} edit={edit} name='cibilLoansBg' />
          <Row params={params} allYrs={allYrs} id='138' updClk={updClk} edit={edit} name='nonOperatingExpenses' />
          <Row params={params} allYrs={allYrs} id='138.1' updClk={updClk} edit={edit} name='nonOperatingExpensesITR' />
          <Row params={params} allYrs={allYrs} id='139' updClk={updClk} edit={edit} name='ccLines' />
          <Row params={params} allYrs={allYrs} id='140' updClk={updClk} edit={edit} name='additionalEquityInfused' />

          <Row params={params} allYrs={allYrs} id='141' updClk={updClk} edit={edit} name='shareHolderLoan' />
          <Row params={params} allYrs={allYrs} id='142' updClk={updClk} edit={edit} name='capitalExpenditure' />
          <Row params={params} allYrs={allYrs} id='143' updClk={updClk} edit={edit} name='unutilizedCcLine' />
          <Row params={params} allYrs={allYrs} id='144' updClk={updClk} edit={edit} name='poValue' />
          <Row params={params} allYrs={allYrs} id='145' updClk={updClk} edit={edit} name='cibilLoanGT12Months' />
          <Row params={params} allYrs={allYrs} id='146' updClk={updClk} edit={edit} name='cibilLoanLT12Months' />

          <Head label='GST' />
          <Row params={params} allYrs={allYrs} id='147' updClk={updClk} edit={edit} name='inventory' />
          <Row params={params} allYrs={allYrs} id='148' updClk={updClk} edit={edit} name='receivables' />
          <Row params={params} allYrs={allYrs} id='149' updClk={updClk} edit={edit} name='advancedReceived' />
          <Row params={params} allYrs={allYrs} id='150' updClk={updClk} edit={edit} name='payables' />
          <Row params={params} allYrs={allYrs} id='151' updClk={updClk} edit={edit} name='advancedPaid' />
          <Row params={params} allYrs={allYrs} id='152' updClk={updClk} edit={edit} name='grossProfitMarginPercent' />
        </tbody></table>
    }

    {/*<div className='g_m_top_200 g_m_bottom_100 g_xlarge'><b>With MCA data from Novel Patterns</b></div>*/}
    {/*
      params &&
      <table><thead className='g_sticky'>
        <tr><td/>
        <td>
          { !allYrs && <ButtonUI onClick={onShowAllClick} transparent={true} label='>>>>>>>>' /> }
          { allYrs && <ButtonUI onClick={onShowRecentClick} transparent={true} label='<<<<<<<<' /> }
        </td>
        {
          params.map((row, i) =>
            <React.Fragment key={i}>
              {
                (i == params.length - 3 || i == params.length - 2 || i == params.length - 1) &&
                <td className='right'>
                  <div className='g_m_left_100'><b className='g_no_wrap'>{row.financialYear}</b></div>
                  {
                    i !== params.length - 1 && row.financialYear !== provisionalYear &&
                    <span className='g_small'>Audited</span>
                  }
                  {
                    row.financialYear === provisionalYear &&
                    <span className='g_small'>Provisional</span>
                  }
                  {
                    i === params.length - 1 && row.financialYear !== provisionalYear &&
                    <span className='g_small'>-</span>
                  }
                </td>
              }
              {
                (i != params.length - 3 && i != params.length - 2 && i != params.length - 1) && allYrs &&
                <td className='right g_ultra_muted'>
                  <div className='g_m_left_100'><b className='g_no_wrap'>{row.financialYear}</b></div>
                  {
                    (i !== params.length - 2 && i !== params.length - 1) &&
                    <span className='g_small'>Audited</span>
                  }
                </td>
              }
            </React.Fragment>
          )
        }
        <td className='spacer-right'></td>
        </tr>
        </thead><tbody>
        <Row params={params} allYrs={allYrs} id='1' name='totalRevenue' />
        <Row params={params} allYrs={allYrs} id='2' name='totalExpenses' />
        <Row params={params} allYrs={allYrs} id='3' name='interestPaid' />
        <Row params={params} allYrs={allYrs} id='4' name='netProfit' />
        <Row params={params} allYrs={allYrs} id='5' name='cashProfit' />
        <Row params={params} allYrs={allYrs} id='6' name='cashProfitPercent' />
        <Row params={params} allYrs={allYrs} id='7' name='ebitda' />
        <Row params={params} allYrs={allYrs} id='8' name='totalReceivables' />
        <Row params={params} allYrs={allYrs} id='9' name='fixedAssets' />
        <Row params={params} allYrs={allYrs} id='10' name='currentAssets' />
        <Row params={params} allYrs={allYrs} id='11' name='cash' />
        <Row params={params} allYrs={allYrs} id='12' name='totalLiability' />
        <Row params={params} allYrs={allYrs} id='13' name='proprietorCapital' />
        <Row params={params} allYrs={allYrs} id='14' name='chargeValue' />
        <Row params={params} allYrs={allYrs} id='18' name='totalCurrentLiability' />
        <Row params={params} allYrs={allYrs} id='19' name='totalDepreciation' />
        <Row params={params} allYrs={allYrs} id='20' name='dscr' />
        <Row params={params} allYrs={allYrs} id='21' name='loanToValueWithCFLoan' />
        <Row params={params} allYrs={allYrs} id='22' name='revenueToNetDebtWithoutCFLoan' />
        <Row params={params} allYrs={allYrs} id='23' name='liabilityToRevenueRatioWithoutCFLoan' />
        <Row params={params} allYrs={allYrs} id='24' name='netDebtToEbitdaWithoutCFLoan' />
        <Row params={params} allYrs={allYrs} id='25' name='receivablesToIncomeRatio' />
        <Row params={params} allYrs={allYrs} id='26' name='dso' />
        <Row params={params} allYrs={allYrs} id='27' name='itrGrossIncome' />
        <Row params={params} allYrs={allYrs} id='28' name='itrTotalExpense' />
        <Row params={params} allYrs={allYrs} id='29' name='itrTotalCashProfit' />
        <Row params={params} allYrs={allYrs} id='30' name='totalNumberOfChequeBounce' />
        <Row params={params} allYrs={allYrs} id='31' name='totalEmiPaid' />
        <Row params={params} allYrs={allYrs} id='32' name='debitsBankAccounts' />
        <Row params={params} allYrs={allYrs} id='33' name='creditsBankAccounts' />
        <Row params={params} allYrs={allYrs} id='34' name='creditExclusions' />
        <Row params={params} allYrs={allYrs} id='35' name='debitExclusions' />
        <Row params={params} allYrs={allYrs} id='36' name='profitBankAccounts' />
        <Row params={params} allYrs={allYrs} id='37' name='financeCost' />
        <Row params={params} allYrs={allYrs} id='38' name='totalLoans' />
        <Row params={params} allYrs={allYrs} id='39' name='minAccountBalance' />
        <Row params={params} allYrs={allYrs} id='40' name='avgAccountBalance' />
        <Row params={params} allYrs={allYrs} id='42' name='gstr1TotalRevenue' />
        <Row params={params} allYrs={allYrs} id='43' name='gstr2TotalExpense' />
        <Row params={params} allYrs={allYrs} id='44' name='poCounterParty' />
        <Row params={params} allYrs={allYrs} id='45' name='companyCreditRating' />
        <Row params={params} allYrs={allYrs} id='46' name='leadDirectorCreditRating' />
        <Row params={params} allYrs={allYrs} id='47' name='ldPaid' />
        <Row params={params} allYrs={allYrs} id='48' name='references' />
        <Row params={params} allYrs={allYrs} id='49' name='stateCount' />
        <Row params={params} allYrs={allYrs} id='50' name='litigationCount' />
        <Row params={params} allYrs={allYrs} id='51' name='trackRecordCompany' />
        <Row params={params} allYrs={allYrs} id='51.1' name='trackRecordPromoter' />
        <Row params={params} allYrs={allYrs} id='52' name='delinquencies' />

        <Head label='Triangulation' />
        <Row params={params} allYrs={allYrs} id='53' name='revenueTriangulationGST' />
        <Row params={params} allYrs={allYrs} id='54' name='revenueTriangulationITR' />
        <Row params={params} allYrs={allYrs} id='55' name='revenueTriangulationBank' />
        <Row params={params} allYrs={allYrs} id='56' name='expenseTriangulationGST' />
        <Row params={params} allYrs={allYrs} id='57' name='expenseTriangulationITR' />
        <Row params={params} allYrs={allYrs} id='58' name='expenseTriangulationBank' />
        <Row params={params} allYrs={allYrs} id='59' name='cashProfitTriangulationGST' />
        <Row params={params} allYrs={allYrs} id='60' name='cashProfitTriangulationITR' />
        <Row params={params} allYrs={allYrs} id='61' name='cashProfitTriangulationBank' />
        <Row params={params} allYrs={allYrs} id='64' name='debtTriangulationBank' />
        <Row params={params} allYrs={allYrs} id='65' name='debtTriangulationITR' />

        <Head label='Other' />
        <Row params={params} allYrs={allYrs} id='1.1' name='totalRevenueFromOperations' />
        <Row params={params} allYrs={allYrs} id='21.1' name='loanToValueWithoutCFLoan' />
        <Row params={params} allYrs={allYrs} id='21.2' name='loanToValue' />
        <Row params={params} allYrs={allYrs} id='22.1' name='revenueToNetDebtWithCFLoan' />
        <Row params={params} allYrs={allYrs} id='22.2' name='revenueToLoanRatio' />
        <Row params={params} allYrs={allYrs} id='23.1' name='liabilityToRevenueRatioWithCFLoan' />
        <Row params={params} allYrs={allYrs} id='23.2' name='liabilityToRevenueRatio' />
        <Row params={params} allYrs={allYrs} id='24.1' name='netDebtToEbitdaWithCFLoan' />
        <Row params={params} allYrs={allYrs} id='24.2' name='netDebtToEbitdaRatio' />
        <Row params={params} allYrs={allYrs} id='30.1' name='chequeBounce' />
        <Row params={params} allYrs={allYrs} id='30.2' name='totalChequeBounceAmount' />
        <Row params={params} allYrs={allYrs} id='101' name='netDebt' />
        <Row params={params} allYrs={allYrs} id='102' name='totalAssets' />
        <Row params={params} allYrs={allYrs} id='103' name='investments' />
        <Row params={params} allYrs={allYrs} id='104' name='taxPaid' />
        <Row params={params} allYrs={allYrs} id='105' name='itrTotalTaxPaid' />
        <Row params={params} allYrs={allYrs} id='106' name='changeInDebitAfterAudit' />
        <Row params={params} allYrs={allYrs} id='107' name='changeInCreditAfterAudit' />
        <Row params={params} allYrs={allYrs} id='108' name='tradeCredits' />
        <Row params={params} allYrs={allYrs} id='109' name='tradeDebits' />
        <Row params={params} allYrs={allYrs} id='110' name='salaries' />
        <Row params={params} allYrs={allYrs} id='111' name='promoterSalaries' />
        <Row params={params} allYrs={allYrs} id='112' name='endingCash' />
        <Row params={params} allYrs={allYrs} id='113' name='closingCash' />
        <Row params={params} allYrs={allYrs} id='114' name='noOfLitigations' />
        <Row params={params} allYrs={allYrs} id='115' name='climeLoan' />
        <Row params={params} allYrs={allYrs} id='116' name='climeLoanTenureMonths' />
        <Row params={params} allYrs={allYrs} id='117' name='climeLoanType' />
        <Row params={params} allYrs={allYrs} id='118' name='totalNumberOfLoanDisbursal' />
        <Row params={params} allYrs={allYrs} id='119' name='totalLoanDisbursalAmount' />
        <Row params={params} allYrs={allYrs} id='120' name='interestPaidBankAccounts' />
        <Row params={params} allYrs={allYrs} id='121' name='totalGrossBlock' />
        <Row params={params} allYrs={allYrs} id='122' name='totalNonCurrentAssets' />
        <Row params={params} allYrs={allYrs} id='123' name='netWorth' />
        <Row params={params} allYrs={allYrs} id='124' name='totalSales' />
        <Row params={params} allYrs={allYrs} id='125' name='salesDebitNotes' />
        <Row params={params} allYrs={allYrs} id='126' name='salesCreditNotes' />
        <Row params={params} allYrs={allYrs} id='127' name='salesAdjustments' />
        <Row params={params} allYrs={allYrs} id='128' name='totalPurchases' />
        <Row params={params} allYrs={allYrs} id='129' name='purchasesDebitNotes' />
        <Row params={params} allYrs={allYrs} id='130' name='purchasesCreditNotes' />
        <Row params={params} allYrs={allYrs} id='131' name='purchasesAdjustments' />
        <Row params={params} allYrs={allYrs} id='132' name='gstLiability' />
        <Row params={params} allYrs={allYrs} id='133' name='inputTaxCreditAvailable' />
        <Row params={params} allYrs={allYrs} id='134' name='itrTotalDebt' />
        <Row params={params} allYrs={allYrs} id='135' name='debitExclusionsM' />
        <Row params={params} allYrs={allYrs} id='136' name='cibilLoans' />
        <Row params={params} allYrs={allYrs} id='137' name='cibilLoansBg' />
        <Row params={params} allYrs={allYrs} id='138' name='nonOperatingExpenses' />
        <Row params={params} allYrs={allYrs} id='139' name='ccLines' />
        <Row params={params} allYrs={allYrs} id='140' name='additionalEquityInfused' />

        <Row params={params} allYrs={allYrs} id='141' name='shareHolderLoan' />
        <Row params={params} allYrs={allYrs} id='142' name='capitalExpenditure' />
      </tbody></table>
    */}

    <SPUpdateModalSF context={context} account={account} updateMode={updateMode}
      onCancelClick={onCancelClick} onUpdate={onUpdate}
      parameterName={parameterName} financialYear={financialYear} parameterValue={parameterValue}
    />
  </div>

const Head = ({ label, showUnused, onShowUnusedCick, onHideUnusedCick }) =>
  <tr>
    <td>
      {
        !showUnused && onShowUnusedCick &&
        <div className="icon icon-angle-right g_m_top_100 g_large g_cursor_pointer" onClick={onShowUnusedCick}></div>
      }
      {
        showUnused && onHideUnusedCick &&
        <div className="icon icon-angle-down g_m_top_100 g_large g_cursor_pointer" onClick={onHideUnusedCick}></div>
      }
    </td>
    <td><div className='g_m_top_100'><b>{label}</b></div></td>
  </tr>

const RowM = ({ params, id, updClk, edit, allYrs, stp, itr, name }) =>
  <Row params={params} id={id} updClk={updClk} edit={edit} allYrs={allYrs}
    name={`${name}${stp ? 'STP' : ''}${itr ? 'ITR' : 'MCA'}`} />

const Row = ({ params, id, name, updClk, edit, allYrs }) =>
  <>
    <tr>
      <td className='g_no_wrap_2'>{id}</td>
      <td className='name'><Desc name={name} /></td>
      {
        params.map((row, i) =>
          <React.Fragment key={i}>
            {
              (i == params.length - 3 || i == params.length - 2 || i == params.length - 1) &&
              <td key={i} className='right data'>
                <span className={`${params[i][name + 'Warn'] ? 'g_error' : ''}`}>
                  {
                    row[name] === 9999999 &&
                    <span className='g_xxlarge'>∞</span>
                  }
                  {
                    row[name] !== 9999999 && <>{row[name]}</>
                  }
                  {
                    updClk && edit &&
                    <span>
                      <span className='icon icon-pencil g_m_left_25 g_cursor_pointer g_ultra_muted' onClick={updClk}
                        data-name={name} data-value={row[name]} data-year={params[i].financialYear}>
                      </span>
                    </span>
                  }
                </span>
              </td>
            }
            {
              (i != params.length - 3 && i != params.length - 2 && i != params.length - 1) && allYrs &&
              <td key={i} className='right'>
                <span className='g_m_left_100 g_ultra_muted'>
                  {
                    row[name] === 9999999 &&
                    <span className='g_xxlarge'>∞</span>
                  }
                  {
                    row[name] !== 9999999 && <>{row[name]}</>
                  }
                  {
                    updClk && edit &&
                    <span>
                      <span className='icon icon-pencil g_m_left_25 g_cursor_pointer g_ultra_muted' onClick={updClk}
                        data-name={name} data-value={row[name]} data-year={params[i].financialYear}>
                      </span>
                    </span>
                  }
                </span>
              </td>
            }
          </React.Fragment>
        )
      }
    </tr>
    {
      edit && params[params.length - 2][name + 'LVList'] && params[params.length - 2][name + 'LVList'].map((dscr, i) =>
        <tr key={i} className={dscr.total ? 'g_h3' : 'g_muted'}>
          <td></td>
          <td className='g_no_wrap_2 g_small'>{dscr.label}</td>
          <td className='g_p_left_100 g_small g_text_right'>{dscr.value}</td>
        </tr>
      )
    }
    {
      params.length > 2 && params[params.length - 3][name + 'Formula'] && edit &&
      <tr>
        <td></td>
        <td colSpan='6' className={`g_muted g_small
          ${params[params.length - 3][name + 'Formula'].includes('null') && 'g_error'}`}
        >
          {params[params.length - 3].financialYear}
          : {params[params.length - 3][name + 'Formula']}
        </td>
      </tr>
    }
    {
      params.length > 1 && params[params.length - 2][name + 'Formula'] &&
      params[0][name + 'Formula'] !== params[params.length - 2][name + 'Formula'] && edit &&
      <tr>
        <td></td>
        <td colSpan='6' className={`g_muted g_small
          ${params[params.length - 2][name + 'Formula'].includes('null') && 'g_error'}`}
        >
          {params[params.length - 2].financialYear}
          : {params[params.length - 2][name + 'Formula']}
        </td>
      </tr>
    }
    {
      params.length > 0 && params[params.length - 1][name + 'Formula'] &&
      params[0][name + 'Formula'] !== params[params.length - 1][name + 'Formula'] && edit &&
      <tr>
        <td></td>
        <td colSpan='6' className={`g_muted g_small
          ${params[params.length - 1][name + 'Formula'].includes('null') && 'g_error'}`}
        >
          {params[params.length - 1].financialYear}
          : {params[params.length - 1][name + 'Formula']}
        </td>
      </tr>
    }
  </>

const Desc = ({ name }) =>
  <span className='g_no_wrap'>
    {(() => {
      switch (name) {
        // Income
        case 'totalRevenueMCA': // 1
          return 'Total revenue (MCA)'
        case 'totalRevenueSTPMCA': // 1
          return 'Total revenue (STP-MCA)'
        case 'totalRevenueITR': // 1
          return 'Total revenue (ITR)'
        case 'totalRevenueSTPITR': // 1
          return 'Total revenue (STP-ITR)'
        case 'totalRevenue': // 1
          return 'Total revenue'

        case 'totalExpensesMCA': // 2
          return 'Total expenses (MCA)'
        case 'totalExpensesSTPMCA': // 2
          return 'Total expenses (STP-MCA)'
        case 'totalExpensesITR': // 2
          return 'Total expenses (ITR)'
        case 'totalExpensesSTPITR': // 2
          return 'Total expenses (STP-ITR)'
        case 'totalExpenses': // 2
          return 'Total expenses'

        case 'interestPaidMCA': // 3
          return 'Interest paid (MCA)'
        case 'interestPaidSTPMCA': // 3
          return 'Interest paid (STP-MCA)'
        case 'interestPaidITR': // 3
          return 'Interest paid (ITR)'
        case 'interestPaidSTPITR': // 3
          return 'Interest paid (STP-ITR)'
        case 'interestPaid': // 3
          return 'Interest paid'

        case 'netProfitMCA': // 4
          return 'Net profit (MCA)'
        case 'netProfitSTPMCA': // 4
          return 'Net profit (STP-MCA)'
        case 'netProfitITR': // 4
          return 'Net profit (ITR)'
        case 'netProfitSTPITR': // 4
          return 'Net profit (STP-ITR)'
        case 'netProfit': // 4
          return 'Net profit'

        case 'cashProfitMCA': // 5
          return 'Cash profit (MCA)'
        case 'cashProfitSTPMCA': // 5
          return 'Cash profit (STP-MCA)'
        case 'cashProfitITR': // 5
          return 'Cash profit (ITR)'
        case 'cashProfitSTPITR': // 5
          return 'Cash profit (STP-ITR)'
        case 'cashProfit': // 5
          return 'Cash profit'

        case 'cashProfitPercentMCA': // 6
          return 'Cash profit % (MCA)'
        case 'cashProfitPercentSTPMCA': // 6
          return 'Cash profit % (STP-MCA)'
        case 'cashProfitPercentITR': // 6
          return 'Cash profit % (ITR)'
        case 'cashProfitPercentSTPITR': // 6
          return 'Cash profit % (STP-ITR)'
        case 'cashProfitPercent': // 6
          return 'Cash profit %'

        case 'ebitdaMCA': // 7
          return 'EBITDA (MCA)'
        case 'ebitdaSTPMCA': // 7
          return 'EBITDA (STP-MCA)'
        case 'ebitdaITR': // 7
          return 'EBITDA (ITR)'
        case 'ebitdaSTPITR': // 7
          return 'EBITDA (STP-ITR)'
        case 'ebitda': // 7
          return 'EBITDA'

        case 'totalReceivablesMCA': // 8
          return 'Total receivables (MCA)'
        case 'totalReceivablesSTPMCA': // 8
          return 'Total receivables (STP-MCA)'
        case 'totalReceivablesITR': // 8
          return 'Total receivables (ITR)'
        case 'totalReceivablesSTPITR': // 8
          return 'Total receivables (STP-ITR)'
        case 'totalReceivables': // 8
          return 'Total receivables'

        case 'fixedAssetsMCA': // 9
          return 'Fixed assets (MCA)'
        case 'fixedAssetsSTPMCA': // 9
          return 'Fixed assets (STP-MCA)'
        case 'fixedAssetsITR': // 9
          return 'Fixed assets (ITR)'
        case 'fixedAssetsSTPITR': // 9
          return 'Fixed assets (STP-ITR)'
        case 'fixedAssets': // 9
          return 'Fixed assets'

        case 'currentAssetsMCA': // 10
          return 'Current assets (MCA)'
        case 'currentAssetsSTPMCA': // 10
          return 'Current assets (STP-MCA)'
        case 'currentAssetsITR': // 10
          return 'Current assets (ITR)'
        case 'currentAssetsSTPITR': // 10
          return 'Current assets (STP-ITR)'
        case 'currentAssets': // 10
          return 'Current assets'

        case 'cashMCA': // 11
          return 'Cash (MCA)'
        case 'cashSTPMCA': // 11
          return 'Cash (STP-MCA)'
        case 'cashITR': // 11
          return 'Cash (ITR)'
        case 'cashSTPITR': // 11
          return 'Cash (STP-ITR)'
        case 'cash': // 11
          return 'Cash'

        case 'totalLiabilityMCA': // 12
          return 'Total liability (MCA)'
        case 'totalLiabilitySTPMCA': // 12
          return 'Total liability (STP-MCA)'
        case 'totalLiabilityITR': // 12
          return 'Total liability (ITR)'
        case 'totalLiabilitySTPITR': // 12
          return 'Total liability (STP-ITR)'
        case 'totalLiability': // 12
          return 'Total liability'

        case 'proprietorCapitalMCA': // 13
          return 'Proprietor capital (MCA)'
        case 'proprietorCapitalSTPMCA': // 13
          return 'Proprietor capital (STP-MCA)'
        case 'proprietorCapitalITR': // 13
          return 'Proprietor capital (ITR)'
        case 'proprietorCapitalSTPITR': // 13
          return 'Proprietor capital (STP-ITR)'
        case 'proprietorCapital': // 13
          return 'Proprietor capital'

        case 'chargeValueMCA': // 14
          return 'Charge value (MCA)'
        case 'chargeValueSTPMCA': // 14
          return 'Charge value (STP-MCA)'
        case 'chargeValueITR': // 14
          return 'Charge value (ITR)'
        case 'chargeValueSTPITR': // 14
          return 'Charge value (STP-ITR)'
        case 'chargeValue': // 14
          return 'Charge value'

        case 'totalLoansClosingMCA': // 15
          return 'Total loans closing (MCA)'
        case 'totalLoansClosingSTPMCA': // 15
          return 'Total loans closing (STP-MCA)'
        case 'totalLoansClosingITR': // 15
          return 'Total loans closing (ITR)'
        case 'totalLoansClosingSTPITR': // 15
          return 'Total loans closing (STP-ITR)'

        case 'totalLoansOpeningMCA': // 16
          return 'Total loans opening (MCA)'
        case 'totalLoansOpeningSTPMCA': // 16
          return 'Total loans opening (STP-MCA)'
        case 'totalLoansOpeningITR': // 16
          return 'Total loans opening (ITR)'
        case 'totalLoansOpeningSTPITR': // 16
          return 'Total loans opening (STP-ITR)'

        case 'newLoansMCA': // 17
          return 'New loans (MCA)'
        case 'newLoansSTPMCA': // 17
          return 'New loans (STP-MCA)'
        case 'newLoansITR': // 17
          return 'New loans (ITR)'
        case 'newLoansSTPITR': // 17
          return 'New loans (STP-ITR)'

        case 'totalCurrentLiabilityMCA': // 18
          return 'Total current liability (MCA)'
        case 'totalCurrentLiabilitySTPMCA': // 18
          return 'Total current liability (STP-MCA)'
        case 'totalCurrentLiabilityITR': // 18
          return 'Total current liability (ITR)'
        case 'totalCurrentLiabilitySTPITR': // 18
          return 'Total current liability (STP-ITR)'
        case 'totalCurrentLiability': // 18
          return 'Total current liability'

        case 'totalDepreciationMCA': // 19
          return 'Total depreciations (MCA)'
        case 'totalDepreciationSTPMCA': // 19
          return 'Total depreciations (STP-MCA)'
        case 'totalDepreciationITR': // 19
          return 'Total depreciations (ITR)'
        case 'totalDepreciationSTPITR': // 19
          return 'Total depreciations (STP-ITR)'
        case 'totalDepreciation': // 19
          return 'Total depreciations'

        case 'dscrMCA': // 20
          return 'DSCR (MCA)'
        case 'dscrSTPMCA': // 20
          return 'DSCR (STP-MCA)'
        case 'dscrITR': // 20
          return 'DSCR (ITR)'
        case 'dscrSTPITR': // 20
          return 'DSCR (STP-ITR)'
        case 'dscr': // 20
          return 'DSCR'
        // xxxx DCSR (bank)

        case 'loanToValueMCA': // 21
          return 'Loan to value (MCA)'
        case 'loanToValueSTPMCA': // 21
          return 'Loan to value (STP-MCA)'
        case 'loanToValueITR': // 21
          return 'Loan to value (ITR)'
        case 'loanToValueSTPITR': // 21
          return 'Loan to value (STP-ITR)'
        case 'loanToValueWithCFLoan': // 21
          return 'Loan to value'

        case 'loanToValueWithoutCFLoanMCA': // 21.1
          return 'Loan to value without CF loan (MCA)'
        case 'loanToValueWithoutCFLoanSTPMCA': // 21.1
          return 'Loan to value without CF loan (STP-MCA)'
        case 'loanToValueWithoutCFLoanITR': // 21.1
          return 'Loan to value without CF loan (ITR)'
        case 'loanToValueWithoutCFLoanSTPITR': // 21.1
          return 'Loan to value without CF loan (STP-ITR)'

        case 'revenueToLoanRatioMCA': // 22
          return 'Revenue to loan (MCA)'
        case 'revenueToLoanRatioSTPMCA': // 22
          return 'Revenue to loan (STP-MCA)'
        case 'revenueToLoanRatioITR': // 22
          return 'Revenue to loan (ITR)'
        case 'revenueToLoanRatioSTPITR': // 22
          return 'Revenue to loan (STP-ITR)'

        case 'liabilityToRevenueRatioMCA': // 23
          return 'Liability to revenue (MCA)'
        case 'liabilityToRevenueRatioSTPMCA': // 23
          return 'Liability to revenue (STP-MCA)'
        case 'liabilityToRevenueRatioITR': // 23
          return 'Liability to revenue (ITR)'
        case 'liabilityToRevenueRatioSTPITR': // 23
          return 'Liability to revenue (STP-ITR)'
        case 'liabilityToRevenueRatioWithoutCFLoan': // 23
          return 'Liabilities to revenue'

        case 'netDebtToEbitdaRatioMCA': // 24
          return 'Net debt to EBITDA (MCA)'
        case 'netDebtToEbitdaRatioSTPMCA': // 24
          return 'Net debt to EBITDA (STP-MCA)'
        case 'netDebtToEbitdaRatioITR': // 24
          return 'Net debt to EBITDA (ITR)'
        case 'netDebtToEbitdaRatioSTPITR': // 24
          return 'Net debt to EBITDA (STP-ITR)'

        case 'receivablesToIncomeRatioMCA': // 25
          return 'Receivables to income (MCA)'
        case 'receivablesToIncomeRatioSTPMCA': // 25
          return 'Receivables to income (STP-MCA)'
        case 'receivablesToIncomeRatioITR': // 25
          return 'Receivables to income (ITR)'
        case 'receivablesToIncomeRatioSTPITR': // 25
          return 'Receivables to income (STP-ITR)'
        case 'receivablesToIncomeRatio': // 25
          return 'Receivables to income'

        case 'dsoMCA': // 26
          return 'DSO (MCA)'
        case 'dsoSTPMCA': // 26
          return 'DSO (STP-MCA)'
        case 'dsoITR': // 26
          return 'DSO (ITR)'
        case 'dsoSTPITR': // 26
          return 'DSO (STP-ITR)'
        case 'dso': // 26
          return 'DSO'

        case 'itrGrossIncome': // 27
          return 'Gross income (ITR-NP)'
        case 'itrGrossIncomeSM': // 27
          return 'Gross income (ITR)'
        case 'itrTotalExpense': // 28
          return 'Total expenses (ITR-NP)'
        case 'itrTotalExpenseSM': // 28
          return 'Total expenses (ITR)'
        case 'itrTotalCashProfit': // 29
          return 'Total cash profit (ITR-NP)'
        case 'itrTotalCashProfitSM': // 29
          return 'Total cash profit (ITR)'
        case 'totalNumberOfChequeBounce': // 30
          return 'Bounce checks (bank)'
        case 'totalEmiPaid': // 31
          return 'Loan repayment and EMI (bank)'
        case 'debitsBankAccounts': // 32
          return 'Summary of all debit (bank)'
        case 'creditsBankAccounts': // 33
          return 'Summary of all credit (bank)'
        case 'creditExclusions': // 34
          return 'Credit exclusions'
        case 'debitExclusions': // 35
          return 'Debit exclusions'
        case 'profitBankAccounts': // 36
          return 'Profit (bank)'
        case 'financeCost': // 37
          return 'Interest paid (bank)'
        case 'totalLoans': // 38
          return 'Total loans (bank)'
        case 'minAccountBalance': // 39
          return 'Minimum cash balance (bank)'
        case 'avgAccountBalance': // 40
          return 'Average cash balance (NP-bank)'
        //
        case 'gstr1TotalRevenue': // 42
          return 'Total revenue (GSTR1)'
        case 'gstr2TotalExpense': // 43
          return 'Total expenses (GSTR2)'
        case 'poCounterParty': // 44
          return 'PO counter party'
        case 'companyCreditRating': // 45
          return 'Company credit rating'
        case 'leadDirectorCreditRating': // 46
          return 'Lead director credit rating'
        case 'ldPaid': // 47
          return 'LD paid'
        case 'references': // 48
          return 'References'
        case 'stateCount': // 49
          return 'State count'
        case 'litigationCount': // 50
          return 'Litigation count'
        case 'trackRecordCompany': // 51
          return 'Company track record (MCA)'
        case 'trackRecordPromoter': // 51.1
          return 'Promoter track record'
        case 'delinquencies': // 52
          return 'Delinquencies '
        // Triangulation
        case 'revenueTriangulationGST': // 53
          return 'Revenue triangulation GST'
        case 'revenueTriangulationITR': // 54
          return 'Revenue triangulation ITR'
        case 'revenueTriangulationBank': // 55
          return 'Revenue triangulation bank'
        case 'expenseTriangulationGST': // 56
          return 'Expense triangulation GST'
        case 'expenseTriangulationITR': // 57
          return 'Expense triangulation ITR'
        case 'expenseTriangulationBank': // 58
          return 'Expense triangulation bank'
        case 'cashProfitTriangulationGST': // 59
          return 'Cash profit triangulation GST'
        case 'cashProfitTriangulationITR': // 60
          return 'Cash profit triangulation ITR'
        case 'cashProfitTriangulationBank': // 61
          return 'Cash profit triangulation bank'
        case 'debtTriangulationBank': // 64
          return 'Debt triangulation bank'
        case 'debtTriangulationITR': // 65
          return 'Debt triangulation ITR'
        // Other
        case 'loanToValueWithoutCFLoan': // 21.1
          return 'Loan to value w/o Clime loan'
        case 'revenueToNetDebtWithCFLoan': // 22.1
          return 'Revenue to net debt with Clime loan'
        case 'revenueToNetDebtMCA': // 22.2
          return 'Revenue to net debt (MCA)'
        case 'revenueToNetDebtWithoutCFLoan': // 22.2
          return 'Revenue to net debt'
        case 'liabilityToRevenueWithCFLoan': // 23.1
          return 'Liability to revenue with Clime loan'
        case 'netDebtToEbitdaWithCFLoan': // 24.1
          return 'Net debt to EBITDA with Clime loan'
        case 'netDebtToEbitdaWithoutCFLoan': // 24.2
          return 'Net debt to EBITDA'
        case 'totalAssets':
          return 'Total assets'
        case 'investments':
          return 'Investments'
        case 'taxPaid':
          return 'Tax paid'
        case 'itrTotalTaxPaid':
          return 'Tax paid ITR'
        case 'changeInDebitAfterAudit':
          return 'Change in debit after audit'
        case 'changeInCreditAfterAudit':
          return 'Change in credit after audit'
        case 'tradeCredits':
          return 'Trade credits'
        case 'tradeDebits':
          return 'Trade debits'
        case 'totalLoansDisbursed':
          return 'Total loans disbursed'
        case 'totalNumberOfLoanDisbursal':
          return 'Total loan disbursal number'
        case 'totalLoanDisbursalAmount':
          return 'Total loan disbursal amount'
        case 'loanDefaults':
          return 'Loan defaults'
        case 'interestPaidBankAccounts':
          return 'Interest paid bank accounts'
        case 'salaries':
          return 'Salaries'
        case 'promoterSalaries':
          return 'Promoter salaries'
        case 'endingCash':
          return 'Ending cash'
        case 'closingCash':
          return 'Closing cash'
        case 'noOfLitigations':
          return 'Legal litigations (MCA)'
        case 'climeLoan':
          return 'Clime loan'
        case 'cibilLoans':
          return 'Total loans (CIBIL)'
        case 'cibilLoansBg':
          return 'Total loans bank guarantee (CIBIL)'
        case 'nonOperatingExpenses':
          return 'Non operating expenses (MCA)'
        case 'nonOperatingExpensesITR':
          return 'Non operating expenses (ITR)'
        case 'ccLines':
          return 'CC lines'
        case 'additionalEquityInfused':
          return 'Additional equity infused'
        case 'shareHolderLoan':
          return 'Share holder loan'
        case 'capitalExpenditure':
          return 'Capital expenditure'
        case 'unutilizedCcLine':
          return 'Unutilized CC line'
        case 'poValue':
          return 'PO Value'
        case 'cibilLoanGT12Months':
          return 'Cibil Loan > 12 months'
        case 'cibilLoanLT12Months':
          return 'Cibil Loan < 12 months'
        case 'inventory':
          return 'Inventory'
        case 'receivables':
          return 'Receivables'
        case 'advancedReceived':
          return 'Advances received'
        case 'payables':
          return 'Payables'
        case 'advancedPaid':
          return 'Advances paid'
        case 'grossProfitMarginPercent':
          return 'Gross Profit Margin %'
        default:
          return name
      }
    })()}
  </span>

const UpdateProvisionals = ({ updateProvisionalsMode, onUpdateProvisionals }) =>
  <div className='g_flex_h'>
    <SpinnerUI show={updateProvisionalsMode} className='g_m_right_50' />
    {/*<ButtonUI label='Update Provisionals' onClick={onUpdateProvisionals} />*/}
  </div>

export default ScoreParamsUI
